export const openPDFInNewTab = (pdfBase64String: string) => {
    const pdfWindow = window.open('');
    (pdfWindow as Window).document.write(
        `<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(pdfBase64String)}'></iframe>`
    );
};